export default __webpack_public_path__ + "static/media/Dominic CV.75d375e4.pdf";